import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MyserviceService } from '../myservice.service';

@Component({
  selector: 'app-error-handling-details',
  templateUrl: './error-handling-details.component.html',
  styleUrls: ['./error-handling-details.component.css']
})
export class ErrorHandlingDetailsComponent implements OnInit {
  inputForm: FormGroup;
  reprocessOptions = [
    { label: 'Ready For User', value: 0 },
    { label: 'Ready To Reprocess', value: 1 },
    { label: 'Ignore', value: 2 },
    { label: 'Processed', value: 3 }
  ];
  invoiceDetails: any;
  constructor(private fb: FormBuilder, private service: MyserviceService) { }

  ngOnInit() {
    this.inputForm = this.fb.group({
      id: [],
      maerskBOL: [],
      carrier: [],
      scac: [],
      coreAdvance: [],
      invoiceNumber: [],
      invoiceDate: [],
      invoiceAmount: [],
      currency: [],
      endAccounting: [],
      reProcessFlag: [],
      usBankID: [],
      errorReason: [],
      fileDateTime: [],
      ediControlNumber: [],
    });

    this.service.getErrorHandlingInfo().subscribe(data => {
      if (data) {
        console.log('Received invoiceDetails: ', data);
        this.invoiceDetails = data;
        this.bindthePartnerInfo(data);
      }
    });
  }
  bindthePartnerInfo(data: any) {
    console.log('-------- ', data);
    
    this.inputForm.patchValue({
      id: data.id || '',
      maerskBOL: data.maerskBOL || '',
      carrier: data.carrier || '',
      scac: data.scac || '',
      coreAdvance: data.coreAdvance || '',
      invoiceNumber: data.invoiceNumber || '',
      invoiceDate: data.invoiceDate || '',
      invoiceAmount: data.invoiceAmount || '',
      currency: data.currency || '',
      endAccounting: data.endAccounting || '',
      reProcessFlag: data.reProcessFlag || '',
      usBankID: data.usBankID || '',
      errorReason: data.errorReason || '',
      fileDateTime: data.fileDateTime || '',
      ediControlNumber: data.ediControlNumber || ''
    });
    this.formatDateTime();
  }
  formatDateTime() {
    const date = new Date(this.inputForm.get('fileDateTime').value); // Assuming you're using a FormControl named 'date'
    const formattedDate = `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    console.log('formattedDate ', formattedDate);
    this.inputForm.get('fileDateTime').patchValue(formattedDate);
  }
  onSubmit() {
    console.log('Form Data:', this.inputForm.value);
  }
}
